import React from 'react';
import { DataGrid } from 'devextreme-react';
import { Item } from 'devextreme-react/form';
import { 
    Paging, 
    Pager, 
    FilterRow, 
    HeaderFilter, 
    ColumnChooser, 
    Column, 
    Lookup,
    Export, 
    Editing,
    Popup,     
    Form, 
    RequiredRule,
    StringLengthRule} from 'devextreme-react/data-grid';

import { createStore } from "../../utils/proxy";
import uri from '../../utils/uri';
import toCapital from '../../utils/common';
import { store } from '../../services/store';
import Title from './Title';
import BlockHeader from './BlockHeader';
import onExporting from '../grids/Importer';

function Entes(props) {

    let dataGrid = React.createRef();

    const { ente, url } = props;

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar '+ ente ,
                icon:'plus',
                type:'default',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.addRow()
            }
        },{
            location: 'after',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }

    
    
    return (
        <div className="container">
            <Title title={ente}/>
            <BlockHeader title={toCapital(ente)}/>          
            <DataGrid id="gridContainer"
                ref={dataGrid}
                selection={{ mode: 'single' }}
                dataSource={store({uri : uri[url]})}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                hoverStateEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onExporting={(e) => onExporting(e, ente)}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={false} fileName={ente} allowExportSelectedData={true} />
                <Column dataField="fullName" width={300} />
                <Column dataField="phoneNumber" caption="Telefono" width={150} />
                <Column dataField="cellNumber"  caption="Celular" width={150} />
                <Column dataField="email" />
                <Column dataField="address" caption="Direccion"/>
                <Column dataField="observation" visible={false} caption="Observacion"/>
                <Column dataField="statuId" width={100} caption="Estado">
                    <Lookup disabled={true} dataSource={createStore({name : 'status'})} valueExpr="id" displayExpr="name" />
                </Column>  
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                    <Popup title={toCapital(ente)} showTitle={true} width={850} height={420}>
                        
                    </Popup>
                    <Form>
                        <Item  dataField="fullName" editorOptions={{ width:300 }} >
                            <RequiredRule message="El nombre es requerido"/>
                            <StringLengthRule max={100} min={2} message="Máximo de caracteres 100 y 2 mínimo"/>
                        </Item>
                        <Item  dataField="phoneNumber" editorOptions={{ width:300 }} >
                            <StringLengthRule max={15} min={0} message="Máximo de caracteres 15 y 2 mínimo"/>
                        </Item>                    
                        <Item  dataField="cellNumber" editorOptions={{ width:300 }} >
                            <StringLengthRule max={15} min={0} message="Máximo de caracteres 15 y 2 mínimo"/>
                        </Item>                    
                        <Item  dataField="email" editorOptions={{ width:300 }} >
                            <StringLengthRule max={50} min={0} message="Máximo de caracteres 50 y 2 mínimo"/>
                        </Item>      
                        <Item  dataField="address" colSpan={2} editorType="dxTextArea" editorOptions={{ height: 50 }} >
                            <RequiredRule message="La direccion es requerida"/>
                            <StringLengthRule max={150} message="Máximo de caracteres 150"/>
                        </Item>                 
                        <Item  dataField="observation" colSpan={2} editorType="dxTextArea" editorOptions={{ height: 50 }} >
                            <StringLengthRule max={250} min={0} message="Máximo de caracteres 250 y 2 mínimo"/>
                        </Item>   
                        <Item  dataField="statuId" >
                            <RequiredRule message="El estado es requerido"/>
                        </Item>                  
                    </Form>
                </Editing>
            </DataGrid>
        </div>
    )

};

export default Entes;